<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in waitFeedbackEnquiryTabs"
          :key="index"
        >
        </el-tab-pane>
      </el-tabs>
      <el-form
        class="search-style-plan"
        :style="{'height':'80px'}"
        label-width="70px"
        label-position="left"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="销售合同：">
              <el-input
                clearable
                v-model.trim="params.contractCode"
                placeholder="请输入关键词"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="品牌："
              clearable
              label-width="50px"
            >
              <el-select
                filterable
                v-model.trim="params.brandName"
              >
                <el-option
                  v-for="(item, index) in brandList"
                  :key="index"
                  :label="item.brandName"
                  :value="item.brandName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="型号："
              clearable
              label-width="50px"
            >
              <el-input
                v-model.trim="params.proType"
                placeholder="请输入关键词"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="订货号："
              clearable
              label-width="60px"
            >
              <el-input
                v-model.trim="params.orderNumber"
                placeholder="请输入关键词"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="入库时间："
              clearable
              label-width="70px"
            >
              <el-date-picker
                v-model.trim="params.inDate"
                style="width:100%;"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col
            :span="18 "
            style="text-align:right;"
          >
            <el-form-item
              label-width="0"
              min-width="100px;"
            >
              <el-button
                @click="searchFor"
                type="primary"
              >搜索
              </el-button>
              <el-button
                @click="searchReset"
                type
              >重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20"></el-row>
      </el-form>
      <div
        class="box-table"
        :style="{height: tableHeight+'px'}"
      >
        <!-- 表格 -->
        <el-table
          ref="multipleTable"
          :data="dataList"
          tooltip-effect="dark"
          :max-height="tableHeight"
          :header-cell-style="tableHeader"
          border
        >
          <el-table-column
            :key="1"
            show-overflow-tooltip
            prop="contractCode"
            label="关联销售合同"
          ></el-table-column>
          <el-table-column
            :key="2"
            show-overflow-tooltip
            prop="brandName"
            label="品牌"
          ></el-table-column>
          <el-table-column
            :key="3"
            show-overflow-tooltip
            prop="proType"
            label="型号"
          ></el-table-column>
          <el-table-column
            :key="4"
            show-overflow-tooltip
            prop="orderNumber"
            label="订货号"
          ></el-table-column>
          <el-table-column
            :key="5"
            show-overflow-tooltip
            prop="count"
            label="退货数量"
          ></el-table-column>
          <el-table-column
            :key="6"
            show-overflow-tooltip
            prop="deliverState"
            label="在库状态"
          ></el-table-column>
          <el-table-column
            :key="7"
            show-overflow-tooltip
            prop="inDate"
            label="入库时间"
          >
            <template slot-scope="scope">{{scope.row.inDate}}</template>
          </el-table-column>
          <el-table-column
            :key="8"
            show-overflow-tooltip
            prop="receiptName"
            label="操作"
          >
            <template slot-scope="scope">
              <div
                class="line-limit-length"
                v-if="activeName === '0'"
              >
                <el-button
                  type="text"
                  @click="onExtract(scope.row)"
                  :key="Math.random()"
                >处理
                </el-button>
              </div>
              <div
                class="line-limit-length"
                v-else
              >
                <el-button
                  type="text"
                  @click="onExamine(scope.row)"
                  :key="Math.random()"
                >查看
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <check-drawer
      :is-display-serial-number="false"
      :visible.sync="drawerViaible"
    >
      <template>
        <check-module :title="`待制定方案产品`">
          <!-- 表格 -->
          <el-table
            ref="multipleTable1"
            :data="[drawerRowData]"
            tooltip-effect="dark"
            max-height="395"
            :header-cell-style="tableHeader"
            border
          >
            <el-table-column
              :key="2"
              show-overflow-tooltip
              prop="brandName"
              label="品牌"
            ></el-table-column>
            <el-table-column
              :key="3"
              show-overflow-tooltip
              prop="proType"
              label="型号"
            ></el-table-column>
            <el-table-column
              :key="4"
              show-overflow-tooltip
              prop="orderNumber"
              label="订货号"
            ></el-table-column>
            <el-table-column
              :key="5"
              show-overflow-tooltip
              prop="goodCount"
              label="退货数量"
            ></el-table-column>
            <el-table-column
              :key="6"
              show-overflow-tooltip
              prop="serialCode"
              label="产品序列号"
            >
              <template v-slot="{row}">
                <el-tree :data="row.codeList"></el-tree>
              </template>
            </el-table-column>
            <el-table-column
              :key="8"
              show-overflow-tooltip
              prop="receiptName"
              label="操作"
            >
              <template slot-scope="scope">
                <div class="line-limit-length">
                  <el-button
                    type="text"
                    @click="downloadTheSerialNumber(scope.row)"
                    :key="Math.random()"
                  >下载序列号
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </check-module>
        <check-module
          style="margin-top: -40px;"
          :title="`退货方案`"
        >
          <template>
            <!-- 表格 -->
            <el-table
              ref="multipleTable2"
              :data="orderSalereGoodsVoList"
              tooltip-effect="dark"
              :span-method="arraySpanMethod"
              max-height="395"
              :header-cell-style="tableHeader"
              border
            >
              <el-table-column
                :key="2"
                show-overflow-tooltip
                prop="pcbNumber"
                label="合同编号"
                width="140"
              >
                <template v-slot="{row}">
                  <div
                    @click="contractDetails(row)"
                    class="approval line-limit-length"
                  >
                    {{
                    row.pcbNumber
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :key="3"
                show-overflow-tooltip
                prop="suName"
                label="供应商名称"
              >
                <template v-slot="{row}">
                  <span
                    @click="onSuName(row)"
                    class="approval line-limit-length"
                  >{{row.suName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                :key="4"
                show-overflow-tooltip
                prop="payPrice"
                label="实付单价"
              ></el-table-column>
              <el-table-column
                :key="5"
                show-overflow-tooltip
                prop="count"
                label="数量"
              >
              <template v-slot="{row}">
                {{row.count}}
              </template>
              </el-table-column>
              <el-table-column
                :key="6"
                prop="receiptCount"
                label="退货数量"
              >
                <template v-slot="{row}">
                  <el-input-number
                    :max="row.max"
                    style="width:100%;"
                    v-if="activeName === '0'"
                    :controls="false"
                    v-model="row.receiptCount"
                    @change="changeNumber(row.index)"
                  ></el-input-number>
                  <div v-else>{{row.receiptCount}}</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="8"
                show-overflow-tooltip
                prop="code"
                label="产品序列号"
              >
                <template v-slot="{row,$index}">
                  <el-button
                    type="text"
                    v-if="!row.serialCode && activeName !== '1'"
                    @click="enterTheSerialNumber(row,$index)"
                  >录入{{row.serialCode}}
                  </el-button>
                  <el-button
                    v-else-if="activeName !== '1'"
                    type="text"
                    @click="editTheSerialNumber(row,$index)"
                  >编辑
                  </el-button>
                  <el-button
                    v-else-if="activeName === '1'"
                    type="text"
                    @click="seeTheSerialNumber(row,$index)"
                  >查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </check-module>
        <div
          class="drawerBtn"
          v-if="activeName === '0'"
          style="position: absolute;left: 20px;bottom: 40px;right:20px;display: flex;justify-content: center"
        >
          <el-button
            type="primary"
            @click="bindSubPlain"
          >提交
          </el-button>
          <el-button @click="drawerViaible = false">关闭</el-button>
        </div>
      </template>
    </check-drawer>
    <in-prouct-serial-code-dialog
      @inProuctSerial="inProuctSerial"
      ref="inProuctSerialCodeRefs"
      :disabled="codeDialogDisabled"
      :title="titleex"
    >
      <template
        #operating
        v-if="codeDialogDisabled"
      >
        <el-button
          type="text"
          @click="downloadTheSerialNumber({
            serialCode
          })"
          style="margin-left:30px;"
        >下载
        </el-button>
      </template>
      <template
        #footer
        v-if="codeDialogDisabled"
      >
        <el-button
          type="primary"
          @click="$refs.inProuctSerialCodeRefs.disableDialog = false"
        >确定
        </el-button>
        <el-button @click="$refs.inProuctSerialCodeRefs.disableDialog = false">取消</el-button>
      </template>
    </in-prouct-serial-code-dialog>
  </div>
</template>

<script>
import { expressionList } from '@/components/utils/data'
import { addScheme, queryGoodDetailsf, queryGoodDetailsProcess, queryPendGood } from '@/api/purchase/purchasePlanList'
import { deepClone } from '@/util'
import { downLoadFileBlob, isSuccess } from '@/util/tool'
import { brandQueryPageAll } from '@/api/product/productManage'

import CheckDrawer from '@/components/checkLayout/module/checkDrawer'
import CheckModule from '@/components/checkLayout/module/checkModule'
import pagination from '@/components/pagination'
import InProuctSerialCodeDialog from '@/views/purchase/purchaseManage/dialog/inProuctSerialCodeDialog'
import { orderDeliverSerialCodeCoe } from '@/api/sell/sellManage'

export default {
  components: {
    InProuctSerialCodeDialog,
    CheckModule,
    CheckDrawer,
    pagination: pagination
  },
  data () {
    return {
      titleex: '录入产品序列号',
      brandList: [],
      localStorage: '',
      activeName: '0', // tabs选中状态
      waitFeedbackEnquiryTabs: [
        {
          name: '0',
          title: '待处理退货产品'
        },
        {
          name: '1',
          title: '已处理退货产品'
        }
      ], // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      params: {
        endValue: ''
      },
      paramsList: {},
      drawerViaible: false, // 抽屉显示
      drawerRowData: {}, // 抽屉数据
      orderSalereGoodsVoList: [],
      expressionList: expressionList,
      checked: false,
      miState: 0, // 列表状态
      time: [],
      tableHeight: window.innerHeight - 430,
      handleWidth: '10',
      dataList: [],
      serialCode: [],
      query: {
        page: 1,
        size: 30,
        state: 0
      },
      codeDialogDisabled: false,
      paramsObj: {
        criteriaVoList: [
          {
            collection: true,
            column: '',
            endValue: '',
            expression: '',
            value: '',
            valueType: ''
          }
        ],
        queryPageName: ''
      }
    }
  },
  mounted () {
    this.getList()
    // 品牌列表
    brandQueryPageAll()
      .then((res) => {
        if (res.data.code === 200) {
          this.brandList = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    searchReset () {
      this.params = {}
      this.getList()
    },
    changeNumber() {
      let max = ''
      const count = this.orderSalereGoodsVoList.reduce((prev, cur) => {
        if (cur.receiptCount) {
          return prev + cur.receiptCount
        }
        return prev + 0
      }, 0)
      if (count) {
        max = this.drawerRowData.goodCount - count
      } else {
        max = this.drawerRowData.goodCount
      }
      this.orderSalereGoodsVoList.forEach((item, i) => {
        if (item.receiptCount) {
          item.max = max + item.receiptCount
        } else {
          item.max = max
        }
      })
    },
    searchFor () {
      const { params } = this
      const paramsObj = deepClone(this.paramsObj)
      if (Object.values(params).every(val => !val)) {
        this.$message.error('请输入查询条件！')
        return
      }
      paramsObj.criteriaVoList = []
      for (const key in params) {
        if (params[key]) {
          paramsObj.criteriaVoList.push({
            collection: true,
            column: key,
            endValue: key === 'inDate' ? params[key][1] : '',
            expression: '',
            value: key === 'inDate' ? params[key][0] : params[key],
            valueType: ''
          })
        }
      }
      this.getList(paramsObj)
    },
    getList (params, query) {
      params = params || deepClone(this.paramsObj)
      query = query || deepClone(this.query)
      query.state = this.activeName
      queryPendGood(params, query).then(res => {
        if (isSuccess(res)) {
          this.dataList = res.data.obj?.records ?? []
          this.total = res.data.obj?.total ?? 0
        }
      })
    },
    onExtract (rowData) {
      queryGoodDetailsf(rowData.ocslcId).then(res => {
        if (isSuccess(res)) {
          this.drawerRowData = res.data.obj || {}
          const { serialCode } = this.drawerRowData
          const obj = {}
          if (serialCode && serialCode.length) {
            obj.label = serialCode[0]
            obj.children = []
            serialCode.forEach((item, index) => {
              if (index !== 0) {
                obj.children.push({
                  label: item
                })
              }
            })
            this.drawerRowData.codeList = [obj]
          }
          this.orderSalereGoodsVoList = this.drawerRowData.orderSalereGoodsVoList || []
          this.orderSalereGoodsVoList = this.orderSalereGoodsVoList.map((item, index) => {
            if (item.goodType === 2) {
              item.pcbNumber = '退至仓库'
            }
            item.max = this.drawerRowData.goodCount
            item.index = index
            return item
          })
          console.log('this.orderSalereGoodsVoList', this.orderSalereGoodsVoList)
          this.drawerViaible = true
        }
      })
    },
    onExamine (rowData) {
      queryGoodDetailsProcess(rowData.ocslcId).then(res => {
        if (isSuccess(res)) {
          this.drawerRowData = res.data.obj || {}
          const { serialCode } = this.drawerRowData
          const obj = {}
          if (serialCode && serialCode.length) {
            obj.label = serialCode[0]
            obj.children = []
            serialCode.forEach((item, index) => {
              if (index !== 0) {
                obj.children.push({
                  label: item
                })
              }
            })
            this.drawerRowData.codeList = [obj]
          }
          this.orderSalereGoodsVoList = this.drawerRowData.orderSalereGoodsVoList || []
          this.orderSalereGoodsVoList = this.orderSalereGoodsVoList.map(item => {
            if (item.goodType === 2) {
              item.pcbNumber = '退至仓库'
            }
            return item
          })
          this.drawerViaible = true
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleClick (obj) {
      this.currentPage = 1
      const query = deepClone(this.query)
      query.state = obj.name
      this.params = {}
      if (obj.name === '1') {
        this.codeDialogDisabled = true
        this.titleex = '查看产品序列号'
      } else {
        this.codeDialogDisabled = false
        this.titleex = '录入产品序列号'
      }
      this.getList(null, query)
    },
    changeQueryParams () {
    },
    handleCurrentChange (val) {
      const query = deepClone(this.query)
      query.page = val
      this.getList(null, query)
    },
    handleSizeChange (val) {
      const query = deepClone(this.query)
      query.size = val
      this.getList(null, query)
    },
    ResetSearch () {
    },
    enterTheSerialNumber (val, index) {
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 0)
    },
    editTheSerialNumber (val, index) {
      this.serialCode = (val.serialCode && val.serialCode.split(';')) || []
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 1)
    },
    seeTheSerialNumber (val, index) {
      val.serialCode = val.code
      this.serialCode = (val.serialCode && val.serialCode.split(';')) || []
      this.$refs.inProuctSerialCodeRefs.onInitial(val, index, 1)
    },

    inProuctSerial (val, index) {
      // value 是序列号  index是操作行
      this.orderSalereGoodsVoList[index].serialCode = val
      this.orderSalereGoodsVoList = deepClone(this.orderSalereGoodsVoList)
    },
    bindSubPlain () {
      const { orderSalereGoodsVoList, drawerRowData } = this
      const { goodCount } = drawerRowData
      if (orderSalereGoodsVoList.reduce((p, n) => {
        if (!n.receiptCount) {
          n.receiptCount = 0
        }
        return n.receiptCount + p
      }, 0) !== goodCount) {
        this.$message.error('退货数量不一致！')
      } else {
        addScheme(Object.assign(drawerRowData, {
          orderSalereGoodsVoList: orderSalereGoodsVoList.map(item => Object.assign(item, {
            code: item.serialCode
          }))
        })).then(res => {
          if (isSuccess(res)) {
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
          this.drawerViaible = false
          this.getList()
        })
      }
    },
    downloadTheSerialNumber (row) {
      if (row.serialCode !== 0) {
        orderDeliverSerialCodeCoe({
          codeUrl: this.$store.state.sellDeliverSerial,
          list: row.serialCode
        }).then((res) => {
          downLoadFileBlob(this, res)
        })
      } else {
        this.$message.error('导出序列号不得为空')
      }
    },
    // 跳转供应商
    onSuName (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 发货编号
    contractDetails (row) {
      if (!row.pcbId) return
      this.$router.push({
        name: 'contractDetails',
        query: { pcbId: row.pcbId }
      })
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (row.goodType === 2) {
        if (columnIndex === 0) {
          return [1, 2]
        } else if (columnIndex === 1) {
          return [0, 0]
        }
      } else {
        return [1, 1]
      }
    }
  }
}

</script>
<style
  scoped
  lang="less"
>
  /deep/ .el-tree {
    background-color: transparent !important;
  }
</style>
